import { DestroyRef, inject } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

/**
 * @see https://netbasal.com/getting-to-know-the-destroyref-provider-in-angular-9791aa096d77
 */
export function injectUntilDestroyed() {
  const subject = new Subject();

  inject(DestroyRef).onDestroy(() => {
    subject.next(true);
    subject.complete();
  });

  return <T>() => takeUntil<T>(subject.asObservable());
}
